import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

interface MessagesCalloutProps {
  isBookkeeperView?: boolean
  payrollRunId: string
  hasMessages: boolean
}

const MessagesCallout = ({
  isBookkeeperView = false,
  payrollRunId,
  hasMessages,
}: MessagesCalloutProps) => {
  const target = isBookkeeperView ? 'client' : 'bookkeeper'

  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideMessagesCalloutByPayrollRun(payrollRunId),
    false
  )

  const handleRemove = () => {
    setIsDismissed(true)
  }

  if (isDismissed || hasMessages) {
    return null
  }

  return (
    <Callout
      type="info"
      title={i18n.t('bookkeepers.clients.payroll_cycles.messages.callout.title')}
      description={i18n.t('bookkeepers.clients.payroll_cycles.messages.callout.description', {
        target,
      })}
      onRemove={handleRemove}
    />
  )
}

export default MessagesCallout
